/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Appearance_LanguageInputs */

const en_settings_v2_appearance_language = /** @type {(inputs: Settings_V2_Appearance_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance & language`)
};

const es_settings_v2_appearance_language = /** @type {(inputs: Settings_V2_Appearance_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apariencia e idioma`)
};

/**
* | output |
* | --- |
* | "Appearance & language" |
*
* @param {Settings_V2_Appearance_LanguageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_appearance_language = /** @type {((inputs?: Settings_V2_Appearance_LanguageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Appearance_LanguageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_appearance_language(inputs)
	return en_settings_v2_appearance_language(inputs)
});